import * as Types from '../actions/Types'

const INITIAL_STATE = {
  selected: null,
  isUpdating: false,
  errorUpdating: null,
  isCreating: false,
  errorCreating: null,
  isDeleting: false,
  errorDeleting: false
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.UPDATE_LAUNDRY:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_LAUNDRY_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_LAUNDRY_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    case Types.CREATE_LAUNDRY:
      return {
        ...state,
        isCreating: true,
        errorCreating: null
      }
    case Types.CREATE_LAUNDRY_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: null
      }
    case Types.CREATE_LAUNDRY_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: payload
      }
    case Types.DELETE_LAUNDRY:
      return {
        ...state,
        isDeleting: true,
        errorDeleting: false
      }
    case Types.DELETE_LAUNDRY_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        errorDeleting: false
      }
    case Types.DELETE_LAUNDRY_FAILED:
      return {
        ...state,
        isDeleting: false,
        errorDeleting: true
      }
    case Types.SHOW_EDIT_LAUNDRY_MODAL:
      return {
        ...state,
        selected: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/Laundries.js